import { Badge } from "~/components/ui/badge";
import { statusBadgeVariant, statusLabel } from "~/lib/format";

export function StatusBadge({ status }: { status?: string | null }) {
  return <Badge variant={statusBadgeVariant(status)}>{statusLabel(status)}</Badge>;
}
